import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Languages, Check } from "lucide-react";
import { SUPPORTED_LANGS } from "../i18n";

/** Compact language switcher — three languages, English/Hindi/Bengali. */
export default function LanguageSwitcher({ variant = "nav" }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = SUPPORTED_LANGS.find((l) => l.code === i18n.language) || SUPPORTED_LANGS[0];

  const pick = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
  };

  return (
    <div className="relative inline-block" data-testid="language-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        className={`inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest rounded-full border-2 border-ink px-2.5 py-1 hover:bg-ink hover:text-cream transition-colors ${variant === "nav" ? "bg-cream text-ink" : ""}`}
        aria-label="Change language"
        data-testid="language-trigger"
      >
        <Languages className="w-3.5 h-3.5" /> {current.short}
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-2 z-50 rounded-2xl border-2 border-ink bg-cream shadow-[6px_6px_0_0_#1A1B41] py-1 min-w-[160px]" data-testid="language-menu">
            {SUPPORTED_LANGS.map((l) => (
              <button
                key={l.code}
                onClick={() => pick(l.code)}
                className="w-full text-left px-3 py-2 text-sm hover:bg-paper flex items-center justify-between gap-3"
                data-testid={`language-option-${l.code}`}
              >
                <span>{l.label}</span>
                {i18n.language === l.code && <Check className="w-3.5 h-3.5 text-teal" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
